/* ============================================================
   kevlts - Maison - interactions
   Lightweight, dependency-free. Powers scroll reveals for the
   custom kevlts homepage sections (.kv-reveal), the showcase
   rotator, and the order-wide cart limit (max 7 units).
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(nodes) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
  }

  function initReveals(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.kv-reveal:not(.is-in)');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealAll(els);
      return;
    }

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- showcase product rotator ---------- */
  function initShowcase(root) {
    var scope = root || document;
    var blocks = scope.querySelectorAll('[data-kv-showcase]');
    blocks.forEach(function (el) {
      if (el.__kvInit) return;
      el.__kvInit = true;

      var slides = el.querySelectorAll('.kv-pslide');
      var dots = el.querySelectorAll('[data-dot]');
      if (slides.length < 2) return;

      var current = 0;
      var delay = parseInt(el.getAttribute('data-autoplay'), 10) || 0;
      var timer = null;

      function show(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
        dots.forEach(function (d, idx) { d.classList.toggle('is-on', idx === current); });
      }

      function play() {
        if (!delay || reduceMotion) return;
        stop();
        timer = setInterval(function () { show(current + 1); }, delay * 1000);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          show(parseInt(d.getAttribute('data-dot'), 10));
          play();
        });
      });

      el.addEventListener('mouseenter', stop);
      el.addEventListener('mouseleave', play);

      show(0);
      play();
    });
  }

  /* ---------- cart limit: max 7 units per order ----------
     cart.item_count is the SUM of every line's quantity, so a single
     product x 7 and 7 products x 1 are both treated as 7.
     Change KV_CART_LIMIT below to adjust the ceiling.            */
  var KV_CART_LIMIT = 7;
  var KV_LIMIT_MESSAGE =
    'You can order a maximum of ' + KV_CART_LIMIT + ' items per order.';
  function kvPartialMessage(remaining) {
    return 'Only ' + remaining + (remaining === 1 ? ' more item' : ' more items') +
      ' can be added - the limit is ' + KV_CART_LIMIT + ' items per order.';
  }

  function kvCartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  /* The limit notice must always render inline (like the theme's own
     add-to-cart errors) - never as a native window.alert popup.
     Two templates render the buy button and they disagree:
       snippets/buy-buttons.liquid       -> ref="addToCartTextError"
       blocks/_product-buy-button.liquid -> no ref, and its modifier class
                                            (hdt-form-message--error) has no
                                            styling outside .hdt-customer /
                                            .hdt-recipient-form, so it renders
                                            unstyled.
     kvErrorBox therefore accepts either markup, creates the box when a form
     ships with neither, and kvStyleErrorBox paints it from the theme's own
     --color-error-text so mobile and desktop match.                        */
  // The gift-card recipient form (snippets/gift-card-recipient-form.liquid)
  // reuses .hdt-form__message-wrapper and is rendered BEFORE the buy button's
  // own box, so plain querySelector would hand back the wrong element on gift
  // card products. Skip anything living inside hdt-recipient-form.
  function kvFindErrorBox(form) {
    var tagged = form.querySelector('[ref="addToCartTextError"]');
    if (tagged) return tagged;

    var candidates = form.querySelectorAll('.hdt-form__message-wrapper');
    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i].closest('hdt-recipient-form, .hdt-recipient-form')) {
        return candidates[i];
      }
    }

    return form.kvErrorBox || null;
  }

  function kvErrorBox(form) {
    var box = kvFindErrorBox(form);

    if (!box) {
      box = document.createElement('div');
      box.className = 'hdt-form__message-wrapper hdt-form__message--error';
      box.setAttribute('role', 'alert');
      box.setAttribute('hidden', '');
      box.innerHTML = '<span class="hdt-error-message"></span>';

      var anchor = form.querySelector('hdt-buy-buttons') ||
        form.querySelector('.hdt-product-form__buttons') ||
        form.querySelector('[type="submit"][name="add"]');

      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor);
      else form.appendChild(box);

      form.kvErrorBox = box;
    }

    return box;
  }

  function kvStyleErrorBox(box) {
    // The block template's class is misspelled (hdt-form-message--error), so
    // add the styled one rather than relying on whichever markup we landed on.
    if (box.classList) box.classList.add('hdt-form__message--error');
    box.style.color = 'rgb(var(--color-error-text))';
    box.style.display = 'flex';
    box.style.alignItems = 'center';
    box.style.gap = '0.7rem';
  }

  function kvShowError(form, message) {
    var box = kvErrorBox(form);
    if (!box) return;
    var text = box.querySelector('.hdt-error-message');
    if (text) text.textContent = message;
    else box.textContent = message;
    kvStyleErrorBox(box);
    box.removeAttribute('hidden');
  }

  function kvHideError(form) {
    var box = kvFindErrorBox(form);
    if (box) box.setAttribute('hidden', '');
  }

  function kvRequestedQty(form) {
    var input = form.querySelector('[name="quantity"]');
    var n = input ? parseInt(input.value, 10) : 1;
    return !n || n < 1 ? 1 : n;
  }

  function kvIsAddToCartForm(form) {
    return (form.getAttribute('action') || '').indexOf('/cart/add') !== -1;
  }

  // Runs in the CAPTURE phase on document, so it fires before the theme's
  // own submit handler (ProductForm in global.min.js) and can cancel it.
  function kvOnSubmit(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM' || !kvIsAddToCartForm(form)) return;

    // Second pass: this submission was already checked and approved.
    if (form.kvApproved) { form.kvApproved = false; return; }

    event.preventDefault();
    event.stopImmediatePropagation();

    var qty = kvRequestedQty(form);
    var submitter = event.submitter || form.querySelector('[type="submit"][name="add"]');

    function letItThrough() {
      if (!form.requestSubmit) return; // very old browser: leave the cart alone
      form.kvApproved = true;
      if (submitter) form.requestSubmit(submitter);
      else form.requestSubmit();
    }

    fetch(kvCartRoot() + 'cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var inCart = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
        var remaining = KV_CART_LIMIT - inCart;

        if (remaining <= 0) {
          kvShowError(form, KV_LIMIT_MESSAGE);
        } else if (qty > remaining) {
          kvShowError(form, kvPartialMessage(remaining));
        } else {
          kvHideError(form);
          letItThrough();
        }
      })
      .catch(function () {
        // If the cart can't be read, never block a genuine sale.
        letItThrough();
      });
  }

  document.addEventListener('submit', kvOnSubmit, true);

  function boot() { initReveals(document); initShowcase(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-scan when sections are re-rendered in the Theme Editor.
  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target);
    initShowcase(e.target);
  });
})();
